import { Store, createStore } from 'vuex'
import { getAuthInfo } from '@/api'

export default createStore({
  state: {
    isCollapse: false, // 侧边栏折叠状态
    // userInfo: JSON.parse(localStorage.getItem('userInfo')) || null, // 用户信息
    userInfo: localStorage.getItem('userInfo') || null, // 用户信息
    token: localStorage.getItem('token') || '', // 用户token
    loginTime: localStorage.getItem('loginTime') || 0, // 登录时间
		routeMenus: [] // 左侧菜单栏
  },
  getters: {
    isCollapse: state => state.isCollapse,
    userInfo: state => state.userInfo,
    token: state => state.token,
    isLogin: state => !!state.token,
    userName: state => state.userInfo?.username || '',
    userRole: state => state.userInfo?.role || '',
    // 检查登录是否过期（假设token有效期为12小时）
    isTokenExpired: state => {
      const now = Date.now()
      const loginTime = parseInt(state.loginTime)
      const expirationTime = 12 * 60 * 60 * 1000 // 12小时
      return now - loginTime > expirationTime
    }
  },
  mutations: {
    // 切换侧边栏折叠状态
    TOGGLE_SIDEBAR(state) {
      state.isCollapse = !state.isCollapse
    },
    // 设置用户信息
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('userInfo', userInfo)
    },
    // 设置token
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
      // 设置登录时间
      const now = Date.now()
      state.loginTime = now
      localStorage.setItem('loginTime', now)
    },
    // 清除登录状态
    CLEAR_LOGIN_STATE(state) {
      state.token = ''
      state.userInfo = null
      state.loginTime = 0
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('loginTime')
    },
    // 更新用户信息的某个字段
    UPDATE_USER_INFO_FIELD(state, { field, value }) {
      if (state.userInfo) {
        state.userInfo[field] = value
        localStorage.setItem('userInfo', state.userInfo)
      }
    },
		SET_BASE_API(state, api) {
			state.baseApi = api
		}
  },
  actions: {
		GetAuthInfo({ commit }) {
			getAuthInfo().then(res=> {
				console.log('storeinfo:', res)
				commit("SET_USER_INFO", res.data)
			})
		},
    // 切换侧边栏
    toggleSidebar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    // 用户登录 - 必须传入真实token
    login({ commit }, { userInfo, token }) {
      return new Promise((resolve, reject) => {
        if (!token) {
          reject(new Error('Token不能为空'))
          return
        }
        commit('SET_USER_INFO', userInfo)
        commit('SET_TOKEN', token)
        resolve()
      })
    },
    // 用户登出
    logout({ commit }) {
      return new Promise((resolve) => {
        commit('CLEAR_LOGIN_STATE')
        resolve()
      })
    },
    // 检查并刷新登录状态
    checkLoginStatus({ getters, commit }) {
      return new Promise((resolve) => {
        if (getters.isTokenExpired) {
          // 登录已过期，清除状态
          commit('CLEAR_LOGIN_STATE')
          resolve(false)
        } else {
          // 登录有效
          resolve(true)
        }
      })
    }
  },
  modules: {}
}) 